<template>
  <div class="main">
    <Header 
      :show="true"
      title="修改角色信息"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-form 
        ref="update"
        @submit="submit"
      >
        <van-field
        v-model.trim="listQuery.name"
        label="名称"
        placeholder="请输入角色名称"
        required
        disabled
        :rules="[{ validator: validCheckName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.remark"
        rows="2"
        autosize
        label="说明"
        type="textarea"
        maxlength="100"
        placeholder="请输入角色说明"
        show-word-limit
      />
      <van-field 
        name="checkboxGroup" 
        label="权限"
        required
      >
        <template #input>
          <div @click="dialogVisiblePermission = true">
            <span v-if="listQuery.permission.length > 0" style="color: #67C23A;">点击修改</span>
            <span v-else style="color: #409EFF;">点击配置</span>
          </div>
        </template>
      </van-field>
      <div style="margin: .6rem 1rem;" v-if="checkPermission([163])">
        <van-button round block type="info" native-type="submit">
          确定
        </van-button>
      </div>
    </van-form>
    
    <el-dialog
      title="上犹万年青"
      :visible.sync="dialogVisiblePermission"
      :append-to-body="true"
      :show-close="true"
      :center="true"
      :modal="false"
      top="0"
      @open="handleOpenDialog"
    >
      <div slot="title">
        <van-notice-bar
          wrapable
          :scrollable="false"
          text="请选择该角色需要的权限，支持多选"
        />
      </div>
      <div style="height: calc(100vh - 0.6rem);">
        <van-collapse v-model="activeNames">
          <van-collapse-item 
            v-for="(member, index) in jsonData"
            :key="index"
            :title="(index+1) + '. ' + member.category.name" 
            :name="member.category.name"
          >
            <van-checkbox-group v-model="checkboxGroup" direction="horizontal">
              <van-checkbox 
                v-for="(detail, index) in member.detail"
                :key="index"
                :name="detail.id" 
                shape="square"
              >
              {{ detail.name }}
              </van-checkbox>
            </van-checkbox-group>
          </van-collapse-item>
        </van-collapse>
        <div style="margin: 16px; margin-bottom: 50px;">
          <van-button round block type="info" @click="handleClickPermission">
            确定
          </van-button>
        </div>
      </div>
    </el-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isChinese } from '@/utils/validate.js'
  import { permission as JsonPermission } from "./permission.json"
  import { updateOne } from '@/api/role.js'

  export default {
    name: "ServiceSystemRoleUpdate",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        dialogVisiblePermission: false,
        isLoading: false,
        loading: false,
        listQuery: {
          serial: '',
          name: '',
          permission: [],
          remark: ''
        },
        jsonData: JsonPermission["list"],
        activeNames: [],
        checkboxGroup: []
      }
    },
    computed: {
      
    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      this.listQuery = this.$route.query
      this.listQuery.permission = this.$route.query.permission.split('|')
      this.listQuery.permission = this.listQuery.permission.map(Number)
      this.checkboxGroup = this.listQuery.permission.map(Number)
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.update.submit()
      },
      submit() {
        if (this.listQuery.permission.length <= 0) {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '权限不能为空')
          return
        }
        Dialog.confirm({
          title: '确认更新角色？',
          message: '角色：' + this.listQuery.name
        }).then(() => {
          this.loading = true
          const data = {
            id: this.listQuery.serial,
            name: this.listQuery.name,
            permissionList: this.listQuery.permission,
            remark: this.listQuery.remark
          }
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新角色', data.message)) {
              this.$router.push({ path:'/service/system/role', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '更新角色', '取消')
        })
      },
      handleOpenDialog() {
        for (let i=0; i<this.jsonData.length; i++) {
          this.activeNames.push(this.jsonData[i].category.name)
        }
      },
      validName(value) {
        return new Promise((resolve) => {
          const result = isChinese(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validPermission(value) {
        return new Promise((resolve) => {
          if ((value === '') || (value === null) || value === undefined || value.length === 0) {
            showPhoneAlarm(true, 'toast', null, 2000, null, '权限不能为空', null)
            resolve(false)
          } else {
            resolve(true)
          }
        })
      },
      handleClickPermission() {
        this.listQuery.permission = this.checkboxGroup
        this.dialogVisiblePermission = false
      }
    }
  }
</script>

<style scoped lang="scss">
  // 系统样式修改
  ::v-deep .el-dialog {
    position: fixed;
    width: 100%;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 13px;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
    overflow-y: auto;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox--horizontal {
    padding: 4px 0;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
